export default __webpack_public_path__ + "static/media/story-5.b85fad65.png";